// eslint-disable-next-line import/named
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { shouldRefreshAccessToken } from '@shared/services/http/tokenRestClient';
import { stringifyError } from '@shared/utils/errorUtils';
import { createSetAccessTokenAction } from '@shared/actions/actions';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
import { HttpModule } from '@shared/services/http/httpProtocol';
import { mergeAccessToken } from '@shared/utils/accessToken';
import { fetchAccessTokens } from '@shared/msal/tokens';
// If token expiration time is less than minimum, token should be refreshed.
const MIN_TIME_UNTIL_EXPIRATION_SEC = 60 * 30; // 30 minutes in seconds.
const logErrorTelemetry = (message, error)=>{
    const payload = {
        page: window.location.href || '',
        action: Constants.Telemetry.Action.RefreshToken,
        actionModifier: Constants.Telemetry.ActionModifier.Error,
        details: JSON.stringify({
            message,
            error: error ? stringifyError(error) : ''
        })
    };
    logger.error(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
};
export const refreshTokenIfNeeded = (store)=>_async_to_generator(function*() {
        const { accessToken } = store.getState().users;
        if (accessToken && shouldRefreshAccessToken(accessToken, MIN_TIME_UNTIL_EXPIRATION_SEC)) {
            try {
                const refreshedAccessToken = yield fetchAccessTokens({
                    resources: [
                        'spza',
                        'arm',
                        'graph',
                        'commerce',
                        'jarvis',
                        'marketplaceLeads',
                        'pifd',
                        'agreement'
                    ]
                });
                if (refreshedAccessToken) {
                    const storedToken = mergeAccessToken({
                        currentAccessToken: accessToken,
                        newAccessToken: refreshedAccessToken
                    });
                    store.dispatch(createSetAccessTokenAction(storedToken));
                    HttpModule.updateAccessToken(storedToken);
                } else {
                    logErrorTelemetry('AppSourceClientHookup fail to refresh token. Null token created.');
                }
            } catch (error) {
                logErrorTelemetry('AppSourceClientHookup fail to refresh token with error', error);
            }
        }
    })();
